import React from 'react';
import { PlayerProfile, PlayerData, PlayerInjury, PlayerTransfer, PlayerAchievement, PlayerStats } from '../../types/player';
import { PlayerProfileHeader } from './PlayerProfileHeader';
import { ArticleReferences } from './ArticleReferences';
import { PlayerInfoTabs } from './PlayerInfoTabs';
import { PlayerDetailsTabs } from './PlayerDetailsTabs';

interface CategoryData {
  category_name: string;
  profile_content: any;
  processing_status: 'completed' | 'failed';
  error_message?: string;
}

interface PlayerProfileCardProps {
  playerProfile: PlayerProfile;
  playerData: PlayerData | null;
  playerInjuries: PlayerInjury[] | null;
  playerTransfers: PlayerTransfer[] | null;
  playerAchievements: PlayerAchievement[] | null;
  playerStats: PlayerStats[] | null;
  isLoading: boolean;
  completedCategories?: CategoryData[];
  onScrollToAnalysis?: () => void;
}

export const PlayerProfileCard: React.FC<PlayerProfileCardProps> = ({
  playerProfile,
  playerData,
  playerInjuries,
  playerTransfers,
  playerAchievements,
  playerStats,
  isLoading,
  completedCategories = [],
  onScrollToAnalysis
}) => {
  return (
    <div className="mt-4">
      <PlayerProfileHeader 
        playerProfile={playerProfile}
        playerData={playerData}
        playerInjuries={playerInjuries}
        playerTransfers={playerTransfers}
        playerAchievements={playerAchievements}
        playerStats={playerStats}
      />
      
      {/* Global Article References Section */}
      {playerData?.article_references && Object.keys(playerData.article_references).length > 0 && (
        <ArticleReferences articleReferences={playerData.article_references} />
      )}
      
      <div className="mb-6 bg-[#121212] rounded-lg shadow-lg border border-gray-500">
        <PlayerInfoTabs 
          playerProfile={playerProfile}
          playerData={playerData}
          playerInjuries={playerInjuries}
          playerTransfers={playerTransfers}
          playerAchievements={playerAchievements}
          playerStats={playerStats}
          isLoading={isLoading}
          completedCategories={completedCategories}
          onScrollToAnalysis={onScrollToAnalysis}
        />
        
        <PlayerDetailsTabs
          playerProfile={playerProfile}
          playerInjuries={playerInjuries}
          playerTransfers={playerTransfers}
          playerAchievements={playerAchievements}
          playerStats={playerStats}
        />
      </div>
    </div>
  );
};